import { ApiInstance } from '..'
import {
  IWithdrawTableParams,
  IDepositListRes,
  IWithdrawListRes,
  IBtcTableParams,
  IWhiteListRes,
  IPengingDataResp,
  IBtcPendingParam,
  SignatureData,
} from './type'

export const getDepositList = (params: IBtcTableParams) => {
  return ApiInstance.post<IDepositListRes>('', { cmd: 'apid.get_unify_deposit_list', para: params })
}
export const getWithdrawList = (params: IWithdrawTableParams) => {
  return ApiInstance.post<IWithdrawListRes>('', { cmd: 'apid.get_withdraw_list', para: params })
}

export const getWhitelist = (params: { btc_addr: string }) => {
  return ApiInstance.post<IWhiteListRes>('', { cmd: 'apid.check_point_white_list', para: params })
}

export const getBtcPendingList = (params: IBtcPendingParam) => {
  return ApiInstance.post<IPengingDataResp>('', { cmd: 'apid.get_brc20_pending', para: params })
}

export const getEvmPendgingList = (params: { chain_id: number; sign: SignatureData }) => {
  return ApiInstance.post<IPengingDataResp>('', { cmd: 'apid.get_erc20_pending', para: params })
}
